import * as React from 'react';
import { ColumnCheckbox } from '@vcd-ecm-ui/GenericGrid';
import { VtxColumnProps } from '@vertexinc/vtx-ui-react-component-library';
import GridRowData from './GridRowData';

const columns: VtxColumnProps<GridRowData>[] = [
  {
    title: 'Product Name',
    dataIndex: 'name',
    className: 'ecwizardColumnStyle',
    sorter: true,
  },
  {
    title: 'Taxability Driver Code',
    dataIndex: 'taxabilityDriverCode',
    className: 'ecwizardColumnStyle',
    sorter: true,
  },
  {
    title: 'Product Class',
    dataIndex: 'productClassInd',
    sorter: true,
    render: (value, row: GridRowData, index: number) => <ColumnCheckbox id="customerCodeLink" align="center" value={value} />,
    width: 150,
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    width: 150,
    align: 'center',
    fixed: 'right',
  },
];

const getDefaultColumns = (): VtxColumnProps<GridRowData>[] => columns;

export default getDefaultColumns;
